module.exports = "/_next/static/images/37717d6c828e66291a6bfb90aed950e5-openAppQrCode.jpg";